// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactInformation-module__font-s-10___QP3LC {
  font-size: 10px !important;
}

.ContactInformation-module__font-s-12___pr4Bw {
  font-size: 12px !important;
}

.ContactInformation-module__font-s-13___CnN0j {
  font-size: 13px !important;
}

.ContactInformation-module__font-s-14____cHJb {
  font-size: 14px !important;
}

.ContactInformation-module__font-s-15___IJetZ {
  font-size: 15px !important;
}

.ContactInformation-module__font-s-16___vsTGH {
  font-size: 16px !important;
}

.ContactInformation-module__font-s-18___aoN7b {
  font-size: 18px !important;
}

.ContactInformation-module__font-s-20___WqVPa {
  font-size: 20px !important;
}

.ContactInformation-module__font-s-22___nZK8P {
  font-size: 22px !important;
}

.ContactInformation-module__font-s-28___hX9tk {
  font-size: 28px !important;
}

.ContactInformation-module__font-w-400___nQ6PK {
  font-weight: 400 !important;
}

.ContactInformation-module__font-w-500___BywIu {
  font-weight: 500 !important;
}

.ContactInformation-module__font-w-600___XSYyX {
  font-weight: 600 !important;
}

.ContactInformation-module__font-w-700___Rp1vc {
  font-weight: 700 !important;
}

.ContactInformation-module__p-5___OcEeo {
  padding: 5px !important;
}

.ContactInformation-module__p-12___FnUqD {
  padding: 12px !important;
}

.ContactInformation-module__p-16___rvbfL {
  padding: 16px !important;
}

.ContactInformation-module__p-30___iVM8E {
  padding: 30px !important;
}

.ContactInformation-module__p-b-0___RNAZe {
  padding-bottom: 0 !important;
}

.ContactInformation-module__p-b-5___qUvPl {
  padding-bottom: 5px !important;
}

.ContactInformation-module__p-b-10___BgnS3 {
  padding-bottom: 10px !important;
}

.ContactInformation-module__p-b-12___BUDUP {
  padding-bottom: 12px !important;
}

.ContactInformation-module__p-b-16___pBI4x {
  padding-bottom: 16px !important;
}

.ContactInformation-module__p-b-18___m6Qr5 {
  padding-bottom: 18px !important;
}

.ContactInformation-module__p-b-20___oRM_b {
  padding-bottom: 20px !important;
}

.ContactInformation-module__p-b-25___Wcexx {
  padding-bottom: 25px !important;
}

.ContactInformation-module__p-b-30___XWQeT {
  padding-bottom: 30px !important;
}

.ContactInformation-module__p-b-50___sHUx4 {
  padding-bottom: 50px !important;
}

.ContactInformation-module__p-t-0___pNKkB {
  padding-top: 0 !important;
}

.ContactInformation-module__p-t-12___n4MDV {
  padding-top: 12px !important;
}

.ContactInformation-module__p-t-16___uEIsx {
  padding-top: 16px !important;
}

.ContactInformation-module__p-t-18___gf5bp {
  padding-top: 18px !important;
}

.ContactInformation-module__p-t-20___uThKR {
  padding-top: 20px !important;
}

.ContactInformation-module__p-t-30___ukb_i {
  padding-top: 30px !important;
}

.ContactInformation-module__p-t-40___TDlF2 {
  padding-top: 40px !important;
}

.ContactInformation-module__p-t-50___RNB1x {
  padding-top: 50px !important;
}

.ContactInformation-module__p-l-20___XvGwJ {
  padding-left: 20px !important;
}

.ContactInformation-module__p-l-30___v3_Yv {
  padding-left: 30px !important;
}

.ContactInformation-module__p-l-40___HbbcU {
  padding-left: 40px !important;
}

.ContactInformation-module__p-r-16____A59O {
  padding-right: 16px !important;
}

.ContactInformation-module__p-r-20___cB_jq {
  padding-right: 20px !important;
}

.ContactInformation-module__p-r-30___e7afy {
  padding-right: 30px !important;
}

.ContactInformation-module__p-r-50___wUwvh {
  padding-right: 50px !important;
}

.ContactInformation-module__p-r-60___fvQEf {
  padding-right: 60px !important;
}

.ContactInformation-module__m-b-1___J_nFF {
  margin-bottom: 1px !important;
}

.ContactInformation-module__m-b-2___fI2jj {
  margin-bottom: 2px !important;
}

.ContactInformation-module__m-b-6___KMf01 {
  margin-bottom: 6px !important;
}

.ContactInformation-module__m-b-8___rdNjx {
  margin-bottom: 8px !important;
}

.ContactInformation-module__m-b-10___huzV2 {
  margin-bottom: 10px !important;
}

.ContactInformation-module__m-b-14___TEb0g {
  margin-bottom: 14px !important;
}

.ContactInformation-module__m-b-16___vqS4H {
  margin-bottom: 16px !important;
}

.ContactInformation-module__m-b-20___JFDHe {
  margin-bottom: 20px !important;
}

.ContactInformation-module__m-b-22___tk8CA {
  margin-bottom: 22px !important;
}

.ContactInformation-module__m-b-24___ZWmuY {
  margin-bottom: 24px !important;
}

.ContactInformation-module__m-b-30___qJtPU {
  margin-bottom: 30px !important;
}

.ContactInformation-module__m-b-32___NNqXW {
  margin-bottom: 32px !important;
}

.ContactInformation-module__m-b-40___SNRYL {
  margin-bottom: 40px !important;
}

.ContactInformation-module__m-t-2___u8Vl9 {
  margin-top: 2px !important;
}

.ContactInformation-module__m-t-3___yDIru {
  margin-top: 3px !important;
}

.ContactInformation-module__m-t-4___ovM0A {
  margin-top: 4px !important;
}

.ContactInformation-module__m-t-5___ntXGb {
  margin-top: 5px !important;
}

.ContactInformation-module__m-t-8___llKtQ {
  margin-top: 8px !important;
}

.ContactInformation-module__m-t-10___eHys6 {
  margin-top: 10px !important;
}

.ContactInformation-module__m-t-15___o4cdO {
  margin-top: 15px !important;
}

.ContactInformation-module__m-t-16___l9GeB {
  margin-top: 16px !important;
}

.ContactInformation-module__m-t-20___tkeyR {
  margin-top: 20px !important;
}

.ContactInformation-module__m-t-22___jkNn9 {
  margin-top: 22px !important;
}

.ContactInformation-module__m-t-30___K47Uh {
  margin-top: 30px !important;
}

.ContactInformation-module__m-t-32___oz5SF {
  margin-top: 32px !important;
}

.ContactInformation-module__m-l-auto___IbXNc {
  margin-left: auto !important;
}

.ContactInformation-module__m-l-4___s5CK2 {
  margin-left: 4px !important;
}

.ContactInformation-module__m-l-5___dv8ol {
  margin-left: 5px !important;
}

.ContactInformation-module__m-l-6___BTa0B {
  margin-left: 6px !important;
}

.ContactInformation-module__m-l-8___gfKsc {
  margin-left: 8px !important;
}

.ContactInformation-module__m-l-10___SMwQy {
  margin-left: 10px !important;
}

.ContactInformation-module__m-l-16___lgj5T {
  margin-left: 16px !important;
}

.ContactInformation-module__m-l-20___Kgfph {
  margin-left: 20px !important;
}

.ContactInformation-module__m-l-24___C8Aja {
  margin-left: 24px !important;
}

.ContactInformation-module__m-l-30___bZ_nK {
  margin-left: 30px !important;
}

.ContactInformation-module__m-l-35___qrsiP {
  margin-left: 35px !important;
}

.ContactInformation-module__m-l-40___Ni5PU {
  margin-left: 40px !important;
}

.ContactInformation-module__m-r-8___Sibot {
  margin-right: 8px !important;
}

.ContactInformation-module__m-r-10___Lwt4g {
  margin-right: 10px !important;
}

.ContactInformation-module__m-r-16___NInTF {
  margin-right: 16px !important;
}

.ContactInformation-module__m-r-20___1AVkw {
  margin-right: 20px !important;
}

.ContactInformation-module__m-r-24___VhPLw {
  margin-right: 24px !important;
}

.ContactInformation-module__m-r-30___dJd_C {
  margin-right: 30px !important;
}

.ContactInformation-module__m-r-40___EfPeK {
  margin-right: 40px !important;
}

.ContactInformation-module__border-r-3___ZZxZx {
  border-radius: 3px !important;
}

.ContactInformation-module__border-r-4___fQbP8 {
  border-radius: 4px !important;
}

.ContactInformation-module__border-r-6___VMbD8 {
  border-radius: 6px !important;
}

.ContactInformation-module__border-r-10___X0SP4 {
  border-radius: 10px !important;
}

.ContactInformation-module__border-r-12___XDK6N {
  border-radius: 12px !important;
}

.ContactInformation-module__border-r-16___YGdBJ {
  border-radius: 16px !important;
}

.ContactInformation-module__border-r-50___aVONd {
  border-radius: 50% !important;
}

.ContactInformation-module__primary-border___E61j6 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ContactInformation-module__primary-border-b___Z104k {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ContactInformation-module__primary-border-t___fyVxR {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ContactInformation-module__primary-border-l___Ccr7E {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ContactInformation-module__primary-border-r___JXi8h {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ContactInformation-module__secondary-border___ZdY43 {
  border: 1px solid #637768;
}

.ContactInformation-module__secondary-border-b___QpuCv {
  border-bottom: 1px solid #637768;
}

.ContactInformation-module__secondary-border-t___uupOu {
  border-top: 1px solid #637768;
}

.ContactInformation-module__secondary-border-l___zkOsn {
  border-left: 1px solid #637768;
}

.ContactInformation-module__secondary-border-r___J0Pu9 {
  border-right: 1px solid #637768;
}

.ContactInformation-module__gap-0___peWLl {
  gap: 0 !important;
}

.ContactInformation-module__gap-2___R3DcQ {
  gap: 2px !important;
}

.ContactInformation-module__gap-4___WDb8B {
  gap: 4px !important;
}

.ContactInformation-module__gap-5___RbJqo {
  gap: 5px !important;
}

.ContactInformation-module__gap-6___DQFz5 {
  gap: 6px !important;
}

.ContactInformation-module__gap-8___vBY3I {
  gap: 8px !important;
}

.ContactInformation-module__gap-10___k8Ela {
  gap: 10px !important;
}

.ContactInformation-module__gap-12___Zf8s6 {
  gap: 12px !important;
}

.ContactInformation-module__gap-14___UWLC6 {
  gap: 14px !important;
}

.ContactInformation-module__gap-16___by1A1 {
  gap: 16px !important;
}

.ContactInformation-module__gap-18___C4erN {
  gap: 18px !important;
}

.ContactInformation-module__gap-20___Te61u {
  gap: 20px !important;
}

.ContactInformation-module__gap-24___TtIHK {
  gap: 24px !important;
}

.ContactInformation-module__gap-26___XailV {
  gap: 26px !important;
}

.ContactInformation-module__gap-30___HNFd1 {
  gap: 30px !important;
}

.ContactInformation-module__gap-32___F3_Yj {
  gap: 32px !important;
}

.ContactInformation-module__gap-40___6Gnvd {
  gap: 40px !important;
}

.ContactInformation-module__gap-50___FIC6c {
  gap: 50px !important;
}

.ContactInformation-module__flex-1___ZSdZ6 {
  flex: 1;
}

.ContactInformation-module__flex-none___zgn4o {
  flex: none !important;
}

.ContactInformation-module__flex-column___NzM1p {
  display: flex;
  flex-direction: column !important;
}

.ContactInformation-module__flex-row___w3AiH {
  display: flex;
  flex-direction: row !important;
}

.ContactInformation-module__vertically-centered___CPBOa {
  display: flex;
  align-items: center !important;
}

.ContactInformation-module__horizontally-centered___ZncTG {
  display: flex;
  justify-content: center !important;
}

.ContactInformation-module__horizontally-end___hPhR8 {
  display: flex;
  justify-content: end !important;
}

.ContactInformation-module__vertically-start___xHYb9 {
  display: flex;
  align-items: start !important;
}

.ContactInformation-module__space-between___GXUih {
  display: flex;
  justify-content: space-between !important;
}

.ContactInformation-module__flex-wrap___hbBjI {
  flex-wrap: wrap !important;
}

.ContactInformation-module__height-100___cytjj {
  height: 100%;
}

.ContactInformation-module__width-50___heDLh {
  width: 50% !important;
}

.ContactInformation-module__width-100___mFzUi {
  width: 100%;
}

.ContactInformation-module__cursor-pointer___Vl1sa {
  cursor: pointer;
}

.ContactInformation-module__cursor-not-allowed___tcpS2 {
  cursor: not-allowed !important;
}

.ContactInformation-module__absolute-centered___jl78f {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ContactInformation-module__absolute___hHroH {
  position: absolute;
}

.ContactInformation-module__relative___xL8dt {
  position: relative;
}

.ContactInformation-module__fixed___VMWeG {
  position: fixed;
}

.ContactInformation-module__visible___HuBHG {
  opacity: 1;
}

.ContactInformation-module__invisible___teaRu {
  opacity: 0;
}

.ContactInformation-module__col-90___WDnFp {
  width: 90% !important;
}

.ContactInformation-module__col-auto___AXj3I {
  width: auto !important;
}

.ContactInformation-module__medical-tabs___PpuK_ {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ContactInformation-module__medical-table-new___dF6Cg {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ContactInformation-module__medical-table-new___dF6Cg:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ContactInformation-module__medical-table-new___dF6Cg::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ContactInformation-module__medical-table-new___dF6Cg::-webkit-scrollbar-track {
  display: none;
}
.ContactInformation-module__medical-table-new___dF6Cg.ContactInformation-module__no-pagination___ByKdk {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ContactInformation-module__medical-table-new___dF6Cg.ContactInformation-module__no-pagination___ByKdk:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ContactInformation-module__medical-table-new___dF6Cg.ContactInformation-module__no-pagination___ByKdk::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ContactInformation-module__medical-table-new___dF6Cg.ContactInformation-module__no-pagination___ByKdk::-webkit-scrollbar-track {
  display: none;
}

.ContactInformation-module__medical-table-empty___MfHT3 {
  padding: 14px 40px !important;
}

.ContactInformation-module__icon-btn___VIBrt {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ContactInformation-module__search-icon___U8NrL {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ContactInformation-module__disable-select___ywLgM {
  user-select: none;
}

.ContactInformation-module__break-word___JPyVe {
  word-break: break-word;
}

.ContactInformation-module__popup-clear-btn___Cl_Ov {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ContactInformation-module__scroll-m-b-20___LLGNI {
  scroll-margin-bottom: 20px;
}

.ContactInformation-module__grid___ymvWa {
  display: grid;
  column-gap: 16px;
  margin-bottom: 6px;
  align-items: center;
  grid-template-columns: 1fr 1fr 1fr 0.4fr;
}
.ContactInformation-module__grid___ymvWa .ContactInformation-module__width50___y5gdf {
  grid-column: 2 span;
}
.ContactInformation-module__grid___ymvWa .ContactInformation-module__button___j2mLc {
  margin-bottom: 8px;
}
.ContactInformation-module__grid___ymvWa .ContactInformation-module__button___j2mLc > img {
  width: 18px;
  height: 18px;
}
.ContactInformation-module__grid___ymvWa .ContactInformation-module__button___j2mLc > span {
  font-size: 14px !important;
}
.ContactInformation-module__grid___ymvWa .ContactInformation-module__checkbox___xM4KK {
  padding: 9px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Profile/forms/ContactInformation/ContactInformation.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;AA8pBF;AA5pBE;EACE,mBAAA;AA8pBJ;AA3pBE;EACE,kBAAA;AA6pBJ;AA3pBI;EACE,WAAA;EACA,YAAA;AA6pBN;AA1pBI;EACE,0BAAA;AA4pBN;AAxpBE;EACE,YAAA;AA0pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.grid {\n  display: grid;\n  column-gap: 16px;\n  margin-bottom: 6px;\n  align-items: center;\n  grid-template-columns: 1fr 1fr 1fr 0.4fr;\n\n  .width50 {\n    grid-column: 2 span;\n  }\n\n  .button {\n    margin-bottom: 8px;\n\n    & > img {\n      width: 18px;\n      height: 18px;\n    }\n\n    & > span {\n      font-size: 14px !important;\n    }\n  }\n\n  .checkbox {\n    padding: 9px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ContactInformation-module__font-s-10___QP3LC`,
	"fontS12": `ContactInformation-module__font-s-12___pr4Bw`,
	"fontS13": `ContactInformation-module__font-s-13___CnN0j`,
	"fontS14": `ContactInformation-module__font-s-14____cHJb`,
	"fontS15": `ContactInformation-module__font-s-15___IJetZ`,
	"fontS16": `ContactInformation-module__font-s-16___vsTGH`,
	"fontS18": `ContactInformation-module__font-s-18___aoN7b`,
	"fontS20": `ContactInformation-module__font-s-20___WqVPa`,
	"fontS22": `ContactInformation-module__font-s-22___nZK8P`,
	"fontS28": `ContactInformation-module__font-s-28___hX9tk`,
	"fontW400": `ContactInformation-module__font-w-400___nQ6PK`,
	"fontW500": `ContactInformation-module__font-w-500___BywIu`,
	"fontW600": `ContactInformation-module__font-w-600___XSYyX`,
	"fontW700": `ContactInformation-module__font-w-700___Rp1vc`,
	"p5": `ContactInformation-module__p-5___OcEeo`,
	"p12": `ContactInformation-module__p-12___FnUqD`,
	"p16": `ContactInformation-module__p-16___rvbfL`,
	"p30": `ContactInformation-module__p-30___iVM8E`,
	"pB0": `ContactInformation-module__p-b-0___RNAZe`,
	"pB5": `ContactInformation-module__p-b-5___qUvPl`,
	"pB10": `ContactInformation-module__p-b-10___BgnS3`,
	"pB12": `ContactInformation-module__p-b-12___BUDUP`,
	"pB16": `ContactInformation-module__p-b-16___pBI4x`,
	"pB18": `ContactInformation-module__p-b-18___m6Qr5`,
	"pB20": `ContactInformation-module__p-b-20___oRM_b`,
	"pB25": `ContactInformation-module__p-b-25___Wcexx`,
	"pB30": `ContactInformation-module__p-b-30___XWQeT`,
	"pB50": `ContactInformation-module__p-b-50___sHUx4`,
	"pT0": `ContactInformation-module__p-t-0___pNKkB`,
	"pT12": `ContactInformation-module__p-t-12___n4MDV`,
	"pT16": `ContactInformation-module__p-t-16___uEIsx`,
	"pT18": `ContactInformation-module__p-t-18___gf5bp`,
	"pT20": `ContactInformation-module__p-t-20___uThKR`,
	"pT30": `ContactInformation-module__p-t-30___ukb_i`,
	"pT40": `ContactInformation-module__p-t-40___TDlF2`,
	"pT50": `ContactInformation-module__p-t-50___RNB1x`,
	"pL20": `ContactInformation-module__p-l-20___XvGwJ`,
	"pL30": `ContactInformation-module__p-l-30___v3_Yv`,
	"pL40": `ContactInformation-module__p-l-40___HbbcU`,
	"pR16": `ContactInformation-module__p-r-16____A59O`,
	"pR20": `ContactInformation-module__p-r-20___cB_jq`,
	"pR30": `ContactInformation-module__p-r-30___e7afy`,
	"pR50": `ContactInformation-module__p-r-50___wUwvh`,
	"pR60": `ContactInformation-module__p-r-60___fvQEf`,
	"mB1": `ContactInformation-module__m-b-1___J_nFF`,
	"mB2": `ContactInformation-module__m-b-2___fI2jj`,
	"mB6": `ContactInformation-module__m-b-6___KMf01`,
	"mB8": `ContactInformation-module__m-b-8___rdNjx`,
	"mB10": `ContactInformation-module__m-b-10___huzV2`,
	"mB14": `ContactInformation-module__m-b-14___TEb0g`,
	"mB16": `ContactInformation-module__m-b-16___vqS4H`,
	"mB20": `ContactInformation-module__m-b-20___JFDHe`,
	"mB22": `ContactInformation-module__m-b-22___tk8CA`,
	"mB24": `ContactInformation-module__m-b-24___ZWmuY`,
	"mB30": `ContactInformation-module__m-b-30___qJtPU`,
	"mB32": `ContactInformation-module__m-b-32___NNqXW`,
	"mB40": `ContactInformation-module__m-b-40___SNRYL`,
	"mT2": `ContactInformation-module__m-t-2___u8Vl9`,
	"mT3": `ContactInformation-module__m-t-3___yDIru`,
	"mT4": `ContactInformation-module__m-t-4___ovM0A`,
	"mT5": `ContactInformation-module__m-t-5___ntXGb`,
	"mT8": `ContactInformation-module__m-t-8___llKtQ`,
	"mT10": `ContactInformation-module__m-t-10___eHys6`,
	"mT15": `ContactInformation-module__m-t-15___o4cdO`,
	"mT16": `ContactInformation-module__m-t-16___l9GeB`,
	"mT20": `ContactInformation-module__m-t-20___tkeyR`,
	"mT22": `ContactInformation-module__m-t-22___jkNn9`,
	"mT30": `ContactInformation-module__m-t-30___K47Uh`,
	"mT32": `ContactInformation-module__m-t-32___oz5SF`,
	"mLAuto": `ContactInformation-module__m-l-auto___IbXNc`,
	"mL4": `ContactInformation-module__m-l-4___s5CK2`,
	"mL5": `ContactInformation-module__m-l-5___dv8ol`,
	"mL6": `ContactInformation-module__m-l-6___BTa0B`,
	"mL8": `ContactInformation-module__m-l-8___gfKsc`,
	"mL10": `ContactInformation-module__m-l-10___SMwQy`,
	"mL16": `ContactInformation-module__m-l-16___lgj5T`,
	"mL20": `ContactInformation-module__m-l-20___Kgfph`,
	"mL24": `ContactInformation-module__m-l-24___C8Aja`,
	"mL30": `ContactInformation-module__m-l-30___bZ_nK`,
	"mL35": `ContactInformation-module__m-l-35___qrsiP`,
	"mL40": `ContactInformation-module__m-l-40___Ni5PU`,
	"mR8": `ContactInformation-module__m-r-8___Sibot`,
	"mR10": `ContactInformation-module__m-r-10___Lwt4g`,
	"mR16": `ContactInformation-module__m-r-16___NInTF`,
	"mR20": `ContactInformation-module__m-r-20___1AVkw`,
	"mR24": `ContactInformation-module__m-r-24___VhPLw`,
	"mR30": `ContactInformation-module__m-r-30___dJd_C`,
	"mR40": `ContactInformation-module__m-r-40___EfPeK`,
	"borderR3": `ContactInformation-module__border-r-3___ZZxZx`,
	"borderR4": `ContactInformation-module__border-r-4___fQbP8`,
	"borderR6": `ContactInformation-module__border-r-6___VMbD8`,
	"borderR10": `ContactInformation-module__border-r-10___X0SP4`,
	"borderR12": `ContactInformation-module__border-r-12___XDK6N`,
	"borderR16": `ContactInformation-module__border-r-16___YGdBJ`,
	"borderR50": `ContactInformation-module__border-r-50___aVONd`,
	"primaryBorder": `ContactInformation-module__primary-border___E61j6`,
	"primaryBorderB": `ContactInformation-module__primary-border-b___Z104k`,
	"primaryBorderT": `ContactInformation-module__primary-border-t___fyVxR`,
	"primaryBorderL": `ContactInformation-module__primary-border-l___Ccr7E`,
	"primaryBorderR": `ContactInformation-module__primary-border-r___JXi8h`,
	"secondaryBorder": `ContactInformation-module__secondary-border___ZdY43`,
	"secondaryBorderB": `ContactInformation-module__secondary-border-b___QpuCv`,
	"secondaryBorderT": `ContactInformation-module__secondary-border-t___uupOu`,
	"secondaryBorderL": `ContactInformation-module__secondary-border-l___zkOsn`,
	"secondaryBorderR": `ContactInformation-module__secondary-border-r___J0Pu9`,
	"gap0": `ContactInformation-module__gap-0___peWLl`,
	"gap2": `ContactInformation-module__gap-2___R3DcQ`,
	"gap4": `ContactInformation-module__gap-4___WDb8B`,
	"gap5": `ContactInformation-module__gap-5___RbJqo`,
	"gap6": `ContactInformation-module__gap-6___DQFz5`,
	"gap8": `ContactInformation-module__gap-8___vBY3I`,
	"gap10": `ContactInformation-module__gap-10___k8Ela`,
	"gap12": `ContactInformation-module__gap-12___Zf8s6`,
	"gap14": `ContactInformation-module__gap-14___UWLC6`,
	"gap16": `ContactInformation-module__gap-16___by1A1`,
	"gap18": `ContactInformation-module__gap-18___C4erN`,
	"gap20": `ContactInformation-module__gap-20___Te61u`,
	"gap24": `ContactInformation-module__gap-24___TtIHK`,
	"gap26": `ContactInformation-module__gap-26___XailV`,
	"gap30": `ContactInformation-module__gap-30___HNFd1`,
	"gap32": `ContactInformation-module__gap-32___F3_Yj`,
	"gap40": `ContactInformation-module__gap-40___6Gnvd`,
	"gap50": `ContactInformation-module__gap-50___FIC6c`,
	"flex1": `ContactInformation-module__flex-1___ZSdZ6`,
	"flexNone": `ContactInformation-module__flex-none___zgn4o`,
	"flexColumn": `ContactInformation-module__flex-column___NzM1p`,
	"flexRow": `ContactInformation-module__flex-row___w3AiH`,
	"verticallyCentered": `ContactInformation-module__vertically-centered___CPBOa`,
	"horizontallyCentered": `ContactInformation-module__horizontally-centered___ZncTG`,
	"horizontallyEnd": `ContactInformation-module__horizontally-end___hPhR8`,
	"verticallyStart": `ContactInformation-module__vertically-start___xHYb9`,
	"spaceBetween": `ContactInformation-module__space-between___GXUih`,
	"flexWrap": `ContactInformation-module__flex-wrap___hbBjI`,
	"height100": `ContactInformation-module__height-100___cytjj`,
	"width50": `ContactInformation-module__width-50___heDLh`,
	"width100": `ContactInformation-module__width-100___mFzUi`,
	"cursorPointer": `ContactInformation-module__cursor-pointer___Vl1sa`,
	"cursorNotAllowed": `ContactInformation-module__cursor-not-allowed___tcpS2`,
	"absoluteCentered": `ContactInformation-module__absolute-centered___jl78f`,
	"absolute": `ContactInformation-module__absolute___hHroH`,
	"relative": `ContactInformation-module__relative___xL8dt`,
	"fixed": `ContactInformation-module__fixed___VMWeG`,
	"visible": `ContactInformation-module__visible___HuBHG`,
	"invisible": `ContactInformation-module__invisible___teaRu`,
	"col90": `ContactInformation-module__col-90___WDnFp`,
	"colAuto": `ContactInformation-module__col-auto___AXj3I`,
	"medicalTabs": `ContactInformation-module__medical-tabs___PpuK_`,
	"medicalTableNew": `ContactInformation-module__medical-table-new___dF6Cg`,
	"noPagination": `ContactInformation-module__no-pagination___ByKdk`,
	"medicalTableEmpty": `ContactInformation-module__medical-table-empty___MfHT3`,
	"iconBtn": `ContactInformation-module__icon-btn___VIBrt`,
	"searchIcon": `ContactInformation-module__search-icon___U8NrL`,
	"disableSelect": `ContactInformation-module__disable-select___ywLgM`,
	"breakWord": `ContactInformation-module__break-word___JPyVe`,
	"popupClearBtn": `ContactInformation-module__popup-clear-btn___Cl_Ov`,
	"scrollMB20": `ContactInformation-module__scroll-m-b-20___LLGNI`,
	"grid": `ContactInformation-module__grid___ymvWa`,
	"width50": `ContactInformation-module__width50___y5gdf`,
	"button": `ContactInformation-module__button___j2mLc`,
	"checkbox": `ContactInformation-module__checkbox___xM4KK`
};
module.exports = ___CSS_LOADER_EXPORT___;
